import React, { Component } from 'react';
import Routes from './components/routes';
import { Provider } from 'react-redux';
import globalStore from './store';

class App extends Component {
  render() {
    return (
      <Provider store={globalStore}>
        <Routes />
      </Provider>
    );
  }
}

export default App;
